import { Icon } from '@assembly-js/design-system';

// The workspace menu previously used hairline outline icons, which read much
// lighter than the solid design-system glyphs the sidebar nav renders beside
// them. Size matches the 14px the nav items use.
const WORKSPACE_MENU_ICON_SIZE = 14;

const iconProps = {
  width: WORKSPACE_MENU_ICON_SIZE,
  height: WORKSPACE_MENU_ICON_SIZE,
};

export const WorkspaceMenuLogoutIcon = () => (
  <Icon icon="LogOut" {...iconProps} />
);
export const WorkspaceMenuLockOpenIcon = () => (
  <Icon icon="Unlock" {...iconProps} />
);
export const WorkspaceMenuPlusIcon = () => <Icon icon="Plus" {...iconProps} />;
